import { createTheme } from '@material-ui/core';

export const themePretest = createTheme({
	palette: {
		primary: {
			main: '#A569BD',
		},
		secondary: {
			main: '#BB8FCE',
		},
		background: {
			default: '#A569BD',
		},
	},
});
